import { PscRiskIQ } from './tabs/psc-riskiq/psc-riskiq';
import { autoinject } from "aurelia-dependency-injection";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel, StepModel } from "../../../../models/basics/basics.models";
import { TasksConstants } from "../../../../models/tasks/task.model";
import { MySubscriptionTabEnum } from "../../../../models/my-subscription/my-subscription.models";
import { InformationServices } from "./tabs/information-services/information-services";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../constants/authentication/claims";
import { UserClientService } from "../../../../services/authentication/user-client.service";

@autoinject
export class MySubscription {

    public tabs: StepModel[] = [];
    public currentTab: StepModel;
    public currentStepKey: string = TasksConstants.InformationServices;
    public selectedCustomerId: number;
    public customerEntityTypes: EntityTypeConfigurationModel[];    
    public isRightShipUser: boolean;
    
    constructor(private informationServices: InformationServices, private pscRiskIQ: PscRiskIQ, private entityTypeConfigurationHelper: EntityTypeConfigurationHelper,
        private userClaimsService: UserClaimsService,
        private userClientService: UserClientService) {    
        this.customerEntityTypes = this.entityTypeConfigurationHelper.getConfigurationWithoutPermissions(["Customers"]);    
        this.isRightShipUser = this.userClaimsService.hasPermission(Claims.RightShipUser);    
    }

    activate() {
        if(!this.isRightShipUser){
            this.selectedCustomerId = this.userClientService.currentUser.settings.customerId;
        }
    }

    attached() {
        this.tabs = this.getTabs();
        this.setCurrentTab();
    }

    setCurrentTab() {
        if (window.history.state && Object.keys(window.history.state).indexOf(TasksConstants.MySubscription) > -1) {
            const tabListName = window.history.state[TasksConstants.MySubscription];
            let step: number = null;

            switch (tabListName) {
                case TasksConstants.InformationServices:
                    step = MySubscriptionTabEnum.InformationServicse;
                    break;
                case TasksConstants.PscRiskIQ:
                    step = MySubscriptionTabEnum.PscRiskIQ;
                    break;
            }

            delete window.history.state[TasksConstants.MySubscription];
            window.history.replaceState(window.history.state, "MySubscription");

            if (step != null) {
                const tabs = this.tabs.filter(x => x.step == step);
                if (tabs && tabs.length > 0)
                    this.currentTab = tabs[0];
            }
        }
    }

    getTabs(): StepModel[] {
        return [
            {
                title: "Information Services",
                step: MySubscriptionTabEnum.InformationServicse,
                show: true,
                vm: this.informationServices
            },
            {
                title: "PSC RiskIQ",
                step: MySubscriptionTabEnum.PscRiskIQ,
                show: true,
                vm: this.pscRiskIQ
            }
        ]
    }

    selectedCustomerChanged(e: any) {
        const detail = e.detail;
        if (detail && detail.selectedEntityUri && detail.selectedEntity) {       
            this.selectedCustomerId = detail.selectedEntity.id;
        }
    }
}